import { render, staticRenderFns } from "./template.html?vue&type=template&id=2272fd8e&scoped=true&external"
import script from "./edit-profile.vue?vue&type=script&lang=js"
export * from "./edit-profile.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=2272fd8e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2272fd8e",
  null
  
)

export default component.exports